<script setup>
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import { faHouse } from "@fortawesome/free-solid-svg-icons"
  import { faRightToBracket } from "@fortawesome/free-solid-svg-icons"
  import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons"
  import { faCirclePlus } from "@fortawesome/free-solid-svg-icons"
  import { faMoneyBill1 } from "@fortawesome/free-solid-svg-icons"
  import { faNavicon } from "@fortawesome/free-solid-svg-icons"
  import { faMicroscope } from "@fortawesome/free-solid-svg-icons"
  import { faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons"

  import { useAuthStore } from "@/stores/auth.js"
  import { useEnvironmentStore } from "@/stores/environmentStore.js";
  import { useRouter } from "vue-router"

  import { toast } from "vue3-toastify"

  import logo from '@/assets/logo.png'
  import { ref, useTemplateRef } from "vue"

  import { Collapse } from 'bootstrap'

  const authStore = useAuthStore()
  const router = useRouter()
  const enviromentStore = useEnvironmentStore()

  const toggleTarget = useTemplateRef( 'toggleTarget' )
  const navShown = ref( false )

  function toggleNav() {
    if ( navShown.value ) {
      new Collapse( toggleTarget.value ).show()
      navShown.value = true
    }
    else {
      new Collapse( toggleTarget.value ).hide()
      navShown.value = false
    }
  }

  function logout() {
    authStore.clearToken()
    toast.success( "You are now logged out" )
    router.push( { name: 'home' } )
  }
</script>

<template lang="pug">
  header
    div
      a( href="https://www.ucuebilliard.com", target="_blank" )
        h3.float-lg-start.mb-0
          img( :src="logo" alt="UCUE Web site" height="65px" )

      nav.navbar.nav-masthead.navbar-expand-lg

        // Added to force the toggler to be on the next line.
        .navbar-brand

        button.navbar-toggler.mb-1( type="button" aria-label="Toggle navigation" ref="toggleButton" @click="toggleNav" )
          font-awesome-icon( :icon="faNavicon" )

        .collapse.navbar-collapse.justify-content-lg-end( ref="toggleTarget" )

          RouterLink.nav-link.d-none.d-lg-block( active-class="active", :to="{ name: 'home' }" )
            font-awesome-icon.me-1( :icon="faHouse" )
            | Home

          RouterLink.nav-link( active-class="active", :to="{ name: 'prices' }", v-if="!authStore.isLoggedIn" )
            font-awesome-icon.me-1( :icon="faMoneyBill1" )
            | Pricing

          span.nav-link.without-border.text-white( v-if="authStore.user" )
            span
              | Hello {{ authStore.user.name }}
              font-awesome-icon.ms-1( :icon="faMicroscope"
                                      v-if="!enviromentStore.isProduction()"
                                      size="xs"
                                      v-tooltip
                                      :data-bs-title="enviromentStore.environment + ' environment'"
                                      data-bs-placement="bottom" )
              RouterLink.text-white( :to="{ name: 'adminDashboard' }", v-if="authStore.isAdmin" )
                font-awesome-icon.ms-3( :icon="faScrewdriverWrench"
                                        size="xs"
                                        data-bs-title="Admin Site"
                                        v-tooltip
                                        data-bs-placement="bottom" )
            button.btn.btn-md.btn-outline-light.ms-3( @click="logout" )
              font-awesome-icon.me-1( :icon="faRightFromBracket" )
              | Logout

          template( v-else )
            RouterLink.nav-link( active-class="active" :to="{ name: 'createAccount' }" )
              font-awesome-icon.me-1.fa-fw( :icon="faCirclePlus" )
              | Create Account
            RouterLink.nav-link( active-class="active", :to="{ name: 'login' }" )
              font-awesome-icon.me-1( :icon="faRightToBracket" )
              | Login

</template>

<style scoped lang="scss">
</style>